module.exports = __webpack_public_path__ + "img/sc.a1e25b02.png";